import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState, AppDispatch } from '../../../../store/store';
import { closeProductFormSafely } from '../../../../store/uiSlice';
import { fetchProducts, clearPersonalDiscounts } from '../../../../store/ProductSlice';
import { PATHS } from '../../../../constants/routes';
import BaseLink from '../../../UI/BaseLink/BaseLink';
import classes from './Header.module.css';

const Header = () => {
    const dispatch = useDispatch<AppDispatch>();
    const isProductFormOpen = useSelector((state: RootState) => state.ui.isProductFormOpen);
    const navigate = useNavigate();

    const handleCloseForm = () => dispatch(closeProductFormSafely());

    const handleLogout = async () => {
        try {
            const tokenRes = await fetch(`${process.env.REACT_APP_SERVER_URL}/csrf-token`, {
                credentials: 'include',
            });
            const { csrfToken } = await tokenRes.json();
            // Отправляем запрос на logout с CSRF-токеном
            const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/admin/logout`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'csrf-token': csrfToken,
                },
            });
            if (res.ok) {
                dispatch(clearPersonalDiscounts());
                dispatch(fetchProducts());
                navigate('/');
            } else {
                console.error('Ошибка при выходе из системы');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
        }
    };

    return (
        <header className={classes.header}>
            {isProductFormOpen && (
                <button onClick={handleCloseForm} className={classes.closeFormButton} title="Отменить изменения">
                    Отмена
                </button>
            )}
            <BaseLink extraClass="headerBtn" title="Перейти в каталог товаров" to={PATHS.showcase} button size={'s'} newTab>
                В каталог
            </BaseLink>
            <button onClick={handleLogout} className={classes.logoutButton}>
                Выход
            </button>
        </header>
    );
};

export default Header;
